import { render, staticRenderFns } from "./ppdt.vue?vue&type=template&id=155a98d4&scoped=true"
import script from "./ppdt.vue?vue&type=script&lang=js"
export * from "./ppdt.vue?vue&type=script&lang=js"
import style0 from "./ppdt.vue?vue&type=style&index=0&id=155a98d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a98d4",
  null
  
)

export default component.exports